module.exports = __webpack_public_path__ + "img/product_44.cc862e4.webp";